import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import { blogArticles } from '../../mock/mockData';

export const KnowledgeHubSection = () => {
  const featured = blogArticles.filter((a) => a.featured).slice(0, 3);
  return (
    <section className="py-16 md:py-20 bg-white" data-testid="knowledge-hub-section">
      <div className="container mx-auto px-4">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
          <div>
            <div className="text-sm font-bold text-alden-green uppercase tracking-widest mb-2">Knowledge Hub</div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">Plan Your Project with Expert Guides</h2>
          </div>
          <Link to="/blog" className="inline-flex items-center gap-2 text-alden-green font-semibold hover:underline" data-testid="knowledge-hub-viewall">
            All Guides <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} data-testid={`home-blog-${a.slug}`}
              className="group rounded-2xl overflow-hidden border-2 border-gray-200 hover:border-alden-green hover:shadow-xl transition-all">
              <div className="h-44 overflow-hidden">
                <img src={a.image} alt={`${a.title} guide`} loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 text-xs text-gray-500 mb-2">
                  <span className="bg-alden-green/10 text-alden-green px-3 py-1 rounded-full font-semibold">{a.category}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{a.readTime}</span>
                </div>
                <h3 className="font-bold text-gray-900 group-hover:text-alden-green transition-colors">{a.title}</h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KnowledgeHubSection;
